import utils from "../../utils";
import classnames from "classnames";
import dictionary from "../../dictionary";

import "./index.scss";
import values from "../../values";
import { GET_FILE } from "../../api/routes";

type Props = {
  role?: string;
  name?: string;
  cssId?: string;
  avatar?: string;
  userId?: string;
  isBlock?: boolean | null | undefined;
  imgSize?: "table-imgAvatar" | "icon-imgAvatar";
  lastName?: string;
  workOnApp?: boolean;
  isDisable?: boolean;
  phoneNumber?: string;
  userBalance?: string;
  mobileNumber?: string;
  hideAvatar?: boolean;
};

const UserInformation = ({
  role,
  name,
  cssId,
  userId,
  avatar,
  isBlock,
  lastName,
  workOnApp,
  isDisable,
  phoneNumber,
  userBalance,
  mobileNumber,
  hideAvatar,
  imgSize = "table-imgAvatar",
}: Props) => {
  const checkNumber = () => {
    if (mobileNumber)
      return `${utils.hyphenfyMobileNumber("0" + mobileNumber)}`;
    else if (phoneNumber) return `${utils.hyphenfyPhoneNumber(phoneNumber)}`;
    else return "وارد نشده";
  };

  const fileUrl = values.constants.BASE_URL_FILE + GET_FILE + "/";

  return (
    <section id={cssId ? cssId : "user-information-container"}>
      {!hideAvatar && isBlock !== null && (
        <div
          className={classnames(
            "block",
            { "is-block": isBlock },
            { disable: isDisable }
          )}
        />
      )}
      {!hideAvatar &&
        (avatar ? (
          <img
            className={classnames(imgSize, "img-avatar")}
            src={avatar}
            alt={name}
          />
        ) : (
          <h2
            className={classnames("letter-avatar", imgSize, {
              "letter-block": isBlock,
            })}
          >
            {lastName
              ? lastName.substring(0, 1)
              : name
              ? name.substring(0, 1)
              : "ن"}
          </h2>
        ))}
      <div className="info">
        <div className="user-name">
          {workOnApp !== undefined && (
            <i
              className={classnames(
                "fa-solid fa-mobile-button",
                { RunApp: workOnApp },
                { deActiveApp: !workOnApp }
              )}
            ></i>
          )}
          <h6 className="user-first-name">{name ? name : "نامشخص"} </h6>
          {lastName && (
            <h6 className="user-lastName">{lastName ? lastName : "نامشخص"}</h6>
          )}
        </div>
        {(mobileNumber || phoneNumber) && (
          <div className="user-phone-role">
            <h3 className="user-phoneNumber">{checkNumber()}</h3>
          </div>
        )}
        {userBalance && (
          <div className="user-phone-role">
            <span className="user-phoneNumber">
              موجودی :
              <span className="user_balance">
                {userBalance.toLocaleString()}
              </span>{" "}
              تومان
            </span>
          </div>
        )}
        <div>
          {role ? (
            <h3 className="user-role">{dictionary.roleDictionary(role)}</h3>
          ) : (
            userId && <h3 className="user-role">{userId}</h3>
          )}
        </div>
      </div>
    </section>
  );
};

export default UserInformation;
